import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 0) {
  if (value === null || value === undefined) return "-";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined) return "-";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatPercent(value, decimals = 1) {
  if (value === null || value === undefined) return "-";
  return `${value.toFixed(decimals)}%`;
}

export function getKPIStatus(value, thresholds) {
  if (!thresholds) return "default";
  if (value >= thresholds.good) return "success";
  if (value <= thresholds.bad) return "danger";
  return "neutral";
}

export function getRankBadgeClass(rank) {
  switch (rank) {
    case 1:
      return "rank-badge rank-badge-1";
    case 2:
      return "rank-badge rank-badge-2";
    case 3:
      return "rank-badge rank-badge-3";
    default:
      return "rank-badge rank-badge-default";
  }
}

export function getStatusBadgeClass(status) {
  switch (status) {
    case "active":
      return "status-badge status-badge-active";
    case "setup":
      return "status-badge status-badge-setup";
    case "completed":
      return "status-badge status-badge-completed";
    default:
      return "status-badge";
  }
}
